var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('v-card',{attrs:{"tile":"","outlined":"","flat":""}},[_c('v-data-table',{staticClass:"custom__table",attrs:{"loading":_vm.loading,"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('status',{attrs:{"status":item.status}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }